'use strict';

const { hydrate } = require('@grpn/hydration');

const EmailSubscriptionForm = require('./email-subscription-form');

module.exports = hydrate('EmailSubscriptionForm', EmailSubscriptionForm);
